<template>
    <v-dialog v-model="dialog" max-width="1024px">
        <loader :loading="isloading"></loader>
        <v-card>
            <v-card-title
                class="text-h5 aviso"
                style="
                    justify-content: center;
                    background: #1d2735;
                    color: white;
                "
            >
                Enviar Mail Factura
            </v-card-title>
            <v-card-text style="text-align: center">
                <v-form ref="form" v-model="valid">
                    <v-row style="margin-top: 1rem">
                        <v-col cols="12">
                            <!-- <v-text-field
                                v-model="emailData"
                                label="Email"
                                outlined
                                placeholder="Escribe la dirección de correo electrónico"
                                :rules="[rules.required, rules.email]"
                            ></v-text-field> -->

                            <v-combobox
                                v-model="emailData"
                                label="Emails"
                                multiple
                                chips
                                outlined
                                placeholder="Escribe una o varias direcciones de correo y presiona Enter"
                                :rules="[rules.required, rules.emailsArray]"
                            ></v-combobox>
                        </v-col>
                        <v-col cols="12">
                            <RichTextComponent
                                v-model="descripcion"
                                :fixedToolbar="false"
                            ></RichTextComponent>
                        </v-col>
                        <v-col cols="12">
                            <v-file-input
                                v-model="files"
                                counter
                                multiple
                                show-size
                                small-chips
                                truncate-length="15"
                                outlined
                                label="Seleccione archivos adjuntos al email"
                            ></v-file-input>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="pt-3">
                <v-spacer></v-spacer>
                <v-btn color="error" large @click="dialog = false"
                    >Cancelar</v-btn
                >

                <v-btn
                    :disabled="isloading"
                    color="success"
                    large
                    @click="SendMail()"
                    >Confirmar</v-btn
                >
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import RichTextComponent from "../../tickets/componentes/RichTextComponent.vue";
import { rules } from "../../../utils/rules";
export default {
    components: {
        RichTextComponent,
    },
    props: ["value", "id_factura", "kit", "devolucion", "email"],
    data() {
        return {
            valid: true,
            descripcion: null,
            files: [],
            dialog: false,
            emailData: [],
            rules: rules,
        };
    },
    created() {
        this.dialog = this.value;
        // Si this.email ya es un array, úsalo, si es string, conviértelo en array
        if (Array.isArray(this.email)) {
            this.emailData = this.email;
        } else if (typeof this.email === "string" && this.email) {
            this.emailData = [this.email];
        } else {
            this.emailData = [];
        }

        this.SetDescripcion();
    },
    watch: {
        value(val) {
            this.dialog = val;
            this.SetDescripcion();
        },
        dialog(val) {
            this.$emit("input", val);
            this.SetDescripcion();
        },
        email(val) {
            if (Array.isArray(val)) {
                this.emailData = val;
            } else if (typeof val === "string" && val) {
                this.emailData = [val];
            } else {
                this.emailData = [];
            }
        },
    },
    computed: {
        isloading: function () {
            return this.$store.getters.getloading;
        },
        isMorning() {
            var currentTime = new Date();
            var currentHour = currentTime.getHours();
            // Define morning hours (for example, 6 AM to 11:59 AM)
            var morningStartHour = 6;
            var morningEndHour = 11;

            // Check if current hour is in the morning
            if (
                currentHour >= morningStartHour &&
                currentHour <= morningEndHour
            ) {
                return true;
            } else {
                return false;
            }
        },
    },
    methods: {
        SetDescripcion() {
            // console.log("prueba");
            this.files = [];
            this.descripcion = `<strong>${
                this.isMorning ? "Buenos días" : "Buenas tardes"
            }</strong>
<p>${
                this.kit
                    ? `Mandamos adjunta factura correspondiente al Kit Digital. Necesitamos que nos envíes el justificante de abono, recuerda que solo tienes que abonar la parte correspondiente al IVA, y anota en el concepto el número de factura  y <strong>el número KD/0000XXXXXX que aparece en esta.</strong>`
                    : `Mandamos adjunta factura. Necesitamos nos envíes el justificante de abono, con el número de factura en el concepto..`
            }
</p>
<strong>Gracias por la confianza.<br />
Un saludo</strong>`;
        },
        async SendMail() {
            if (this.isloading) return;

            this.$refs.form.validate();
            if (!this.valid) return;

            try {
                const formData = new FormData();
                formData.append("descripcion", this.descripcion);

                // Añade cada archivo al FormData
                this.emailData.forEach((email, index) => {
                    formData.append(`emails[]`, email); // Usa `files[]` para indicar un array de archivos
                });

                // Añade cada archivo al FormData
                this.files.forEach((file, index) => {
                    formData.append(`files[]`, file); // Usa `files[]` para indicar un array de archivos
                });

                // Si es factura de devolucion
                if (this.devolucion) {
                    try {
                        const res = await axios.post(
                            `api/facturas/devolucion/mail/${this.id_factura}`,
                            formData
                        );
                    } catch (ex) {}
                } else {
                    // Factura normal
                    try {
                        const res = await axios.post(
                            `api/facturas/mail/${this.id_factura}`,
                            formData,
                            {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                },
                            }
                        );
                    } catch (ex) {}
                }

                this.$emit("Sent");
                this.dialog = false;
            } catch (ex) {
                console.log(ex);
            }
        },
    },
};
</script>
